var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDispute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.375C10.4922 0.375 10.9492 0.65625 11.1953 1.07812L18.7891 14.0156C19.0352 14.4727 19.0352 15 18.7891 15.4219C18.543 15.8789 18.0859 16.125 17.5938 16.125H2.40625C1.87891 16.125 1.42188 15.8789 1.17578 15.4219C0.929688 15 0.929688 14.4727 1.17578 14.0156L8.76953 1.07812C9.01562 0.65625 9.47266 0.375 10 0.375ZM10 4.875C9.50781 4.875 9.15625 5.26172 9.15625 5.71875V9.65625C9.15625 10.1484 9.50781 10.5 10 10.5C10.457 10.5 10.8438 10.1484 10.8438 9.65625V5.71875C10.8438 5.26172 10.457 4.875 10 4.875ZM11.125 12.75C11.125 12.1523 10.5977 11.625 10 11.625C9.36719 11.625 8.875 12.1523 8.875 12.75C8.875 13.3828 9.36719 13.875 10 13.875C10.5977 13.875 11.125 13.3828 11.125 12.75Z",
    fill: "#5954DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispute);
export default __webpack_public_path__ + "static/media/Dispute.6c9f79e0f8172fe9af16c43df7cf944c.svg";
export { ForwardRef as ReactComponent };